export default __webpack_public_path__ + "static/media/composer.dcae06d6.svg";